<template>
    <div class="card mb-4">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label><label style="color: red; height: 2px;" >*</label>
                            از تاریخ</label>
                        <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="fromDate" :locale-config="{
                            fa: {
                                displayFormat: 'jYYYY/jMM/jDD',
                                lang: {label: 'شمسی'}
                            }
                        }" />
                    </div>
                </div>
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        تا تاریخ</label>
                    <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="toDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label>کد ملی / شناسه ملی</label>
                    <input class="form-control ltr-input" v-model="nationalCode" v-mask="'###########'">
                </div>
                <div class="col-md-3">
                    <label>شماره کارت</label>
                    <input class="form-control ltr-input" v-model="pan" v-mask="'####-####-####-####'">
                </div>
                <div class="col-md-3">
                    <label>شماره همراه</label>
                    <input class="form-control ltr-input" v-model="mobile" v-mask="'####-#######'">
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>نوع کارت</label>
                        <Vselect v-model="cType" :reduce="item => item.cardTypeId" label="title" :options="cardTypes">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>شعبه</label>
                        <Vselect v-model="domainDataId" :reduce="item => item.domainDataId" label="fullName" :options="allDomainData">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>شارژ شده</label>
                        <select class="form-control" v-model="deposit">
                            <option :value="null" selected>همه</option>
                            <option value="1">بله</option>
                            <option value="0">خیر</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>وضعیت</label>
                        <Vselect v-model="orderStatus" :reduce="item => item.flowStepStatusId" label="title" :options="flowStepStatusesId">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
            </div>
            <div class="row" style="justify-content: center;">
                <div class="col-md-3" style="margin-top: 29px;">
                    <button class="btn btn-primary btn-block" @click="submit" :disabled="!fromDate || !toDate">
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
                <div v-if="rows.length" class="col-md-3" style="margin-top: 29px;">
                    <button class="btn btn-secondary" @click="downloadExcelFile" >دریافت خروجی Excel</button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length">
            <table class="table table-hover table-bordered mb-0" v-if="rows.length">
                <thead>
                    <tr>
                        <th>دارنده کارت</th>
                        <th>کد ملی</th>
                        <th>شماره همراه</th>
                        <th>شماره کارت</th>
                        <th>نوع کارت</th>
                        <th>طرح کارت</th>
                        <th>وضعیت سفارش</th>
                        <th>وضعیت فعلی کارت</th>
                        <th>محل صدور</th>
                        <th>صادر کننده</th>
                        <th>شارژ</th>
                        <th>تاریخ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,index) in rows" :key="index">
                        <td>{{ row.first_name + ' ' + row.last_name }}</td>
                        <td>{{ row.national_code }}</td>
                        <td>{{ row.mobile }}</td>
                        <td dir="ltr">{{ row.mask_pan }}</td>
                        <td>{{ row.card_type }}</td>
                        <td>{{ row.them_titlte || '-' }}</td>
                        <td>{{ row.flow_step_title }}</td>
                        <td>{{ row.flow_step_status_title }}</td>
                        <td>{{ row.parent_domain_data_title }}</td>
                        <td>{{ row.buyer_name }}</td>
                        <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(row.deposit_amount) }} ریال</td>
                        <td>{{ row.order_date.replace(/\//g,'').slice(0,4) + '/' + row.order_date.replace(/\//g,'').slice(4,6) + '/' + row.order_date.replace(/\//g,'').slice(6,8) }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"><i class="icon ion-ios-arrow-forward"></i></a>
                        </li>
                        <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="page in pages" :key="page">
                            <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"><i class="icon ion-ios-arrow-back"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
            <p v-if="rows.length" class="mt-3 mb-0">مبلغ شارژ کارت : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(amount) }} ریال</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'CustomerReport',
    data(){
        return {
            showLoading: true,
            isSearched: false,
            rows: [],
            cardTypes: [],
            flowStepStatusesId: [],
            fromDate: '',
            today: moment().format('jYYYY-jMM-jDD'),
            toDate: '',
            currentPage: 1,
            orderStatus: '',
            pan: '',
            nationalCode: '',
            domainDataId: '',
            rrn: '',
            pages: [1],
            cType: '',
            domainData: [],
            allDomainData: [],
            perPage: 100,
            deposit: null,
            mobile: '',
            amount: 0,
            count: 0
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        }
    },
    methods: {
        baseData(){
            this.$api.get('Cards/Types').then(({data}) => {
                this.cardTypes = data.result;
            });
            this.$api.get('Flows/0').then(({data}) => {
                if(data.status){
                    let flowStepStatusesId = [];
                    data.result.map(flowStep => {
                        flowStep.flowStepStatuses.map(flowStepStatus => {
                            if(!flowStepStatusesId.find(flow => flow.flowStepStatusId == flowStepStatus.flowStepStatusId))
                                flowStepStatusesId.push({
                                    flowStepStatusId: flowStepStatus.flowStepStatusId,
                                    title: flowStepStatus.title
                                });
                        })
                    })
                    this.flowStepStatusesId = flowStepStatusesId;
                }
            });
            this.$api.post('User/GetDomainData',{domainId: 3}).then(({data}) => {
                if(data.status){
                    this.allDomainData = data.result;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getData(excel = false){
            this.showLoading = true;
            const postedData = {
                p_fromdate: this.fromDate.replace(/\//g,''),
                p_todate: this.toDate.replace(/\//g,''),
                p_offset: this.currentPage,
                p_limit: this.perPage,
                p_national: this.nationalCode,
                p_pan: this.pan.replace(/-/g,''),
                p_flow_status: this.orderStatus != '' ? this.orderStatus : 0,
                p_mobile: this.mobile.replace(/-/g,''),
                p_cType: this.cType || 0,
                p_source_domain: this.domainDataId || 0,
                p_deposit: this.deposit || null,
                excel
            };
            this.$api.post('Branches/Report/DetailGift',postedData).then(({data}) => {
                if(data.status && excel)
                    window.open('https://cardapi.sabinarya.com/download/' + data.result.fileName)
                if(data.status && data.result && data.result.v_result){
                    this.rows = data.result.v_result;
                    this.count = data.result.v_count[0].cnt_total;
                    this.amount = data.result.v_count[0].amt_amount;
                    let calcPages = Math.ceil((this.count) / this.perPage);
                    calcPages = calcPages > 1 ? calcPages : 1
                    let pagesArray = [];
                    for(let i = 1;i <= calcPages;i++)
                        pagesArray.push(i);
                    this.pages = pagesArray;
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        downloadExcelFile(){
            this.getData(true);
        },
        submit(){
            this.getData();
        }
    },
    created(){
        this.baseData();
    }
}
</script>